// ThemeToggle — bouton bascule clair/sombre (Design System GoWele).
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getPreferredTheme, setTheme } from '../../../utils/theme';

const ThemeToggle = ({ className = '' }) => {
  const { t } = useTranslation('common');
  const [theme, setLocal] = useState(getPreferredTheme());
  const isDark = theme === 'dark';

  const toggle = () => {
    const next = isDark ? 'light' : 'dark';
    setTheme(next);
    setLocal(next);
  };

  return (
    <button
      type="button"
      onClick={toggle}
      className={`theme-toggle ${className}`}
      aria-label={t('ui.toggleTheme')}
      title={isDark ? t('ui.themeLight') : t('ui.themeDark')}
      aria-pressed={isDark}
      style={{
        background: 'transparent', border: '1px solid var(--color-border, #e5e7eb)',
        borderRadius: 'var(--radius-full, 9999px)', width: 36, height: 36, cursor: 'pointer',
        display: 'inline-flex', alignItems: 'center', justifyContent: 'center', fontSize: 16,
        color: 'var(--color-text-secondary, #374151)', transition: 'var(--transition-fast, 150ms ease)',
      }}
    >
      {isDark ? '☀️' : '🌙'}
    </button>
  );
};

export default ThemeToggle;
